import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../../../styles/medics.scss';
import Input from '../../../components/elements/input/Input';
import Select from '../../../components/elements/select/Select';
import { fetchAllClinics, fetchSingleClinic } from '../../../api/medics-api';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Alert } from 'antd';
import ContentLayout from '../../../layout/ContentLayout';
import { editClinic } from '../../../api/user-api';

const EditClinic = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;

  const [data, setData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const [dataFormErrors, setDataFormErrors] = useState({
    name: false,
    email: false,
    password: false,
  });
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const toogleShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleFetchUser = async () => {
    const { data, success, message } = await fetchSingleClinic(id);

    if (!success) {
      toast.error(message || 'Error while fetching the data!');
      return;
    }

    setData({
      name: data.name,
      email: data.email,
      password: '',
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateInputs = () => {
    const { name, email, password } = data;

    if (!name.trim()) {
      setError('Unesite naziv organizacije.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    // password to contain at least one uppercase, one lowercase, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%_.,#+])[A-Za-z\d!$%_.,#+]{8,}$/;
    if (passwordVisible && !passwordRegex.test(password)) {
      setError(
        'Lozinka mora sadržati najmanje 8 karaktera, uključujući veliko i malo slovo, broj i specijalni karakter (!$%_.,#+).'
      );
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    const isValid = validateInputs();
    if (!isValid) {
      setLoading(false);
      return;
    }
    toast.loading('Ažuriranje podataka...');

    const payload = passwordVisible
      ? {
          name: data.name,
          email: data.email,
          password: data.password,
        }
      : {
          name: data.name,
          email: data.email,
        };

    try {
      const response = await editClinic({
        id,
        payload,
      });

      if (!response.success) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        toast.dismiss();
        toast.error('Došlo je do greške pri ažuriranju podataka.');
        return;
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.success('Podaci uspešno ažurirani.');
    } catch (error) {
      console.error('Error updating clinic:', error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.error('Došlo je do greške pri ažuriranju podataka.');
    }
  };

  useEffect(() => {
    if (id) {
      handleFetchUser();
    }
  }, [id]);

  const handleOpenModal = () => {};

  return (
    <ContentLayout>
      <div className="edit_medic_wrapper">
        <div className="edit_medic_container">
          <div className="edit_medic_header">
            <Link
              to={'/korisnici?tab=organizacije'}
              className="link_btn"
              style={{ marginLeft: 0 }}
            >
              <img alt="back image" src="/assets/icons/chevron.svg" />
              <span>Nazad</span>
            </Link>
          </div>

          <div className="edit_medic_form_container">
            <div className="edit_medic_form_wrapper">
              <div className="form_header">
                <span className="form_title">Uredi organizaciju</span>
              </div>

              <form className="edit_medic_form">
                <div className="grid_row">
                  <div className="cell">
                    <span className="label">Ime organizacije</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="name"
                      id="name"
                      value={data.name}
                      placeholder="Ime organizacije"
                    />
                  </div>
                  <div className="cell">
                    <span className="label">Adresa e-pošte</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="email"
                      id="email"
                      value={data.email}
                      placeholder="example@email.com"
                    />
                  </div>
                  <div className="cell">
                    {passwordVisible ? (
                      <>
                        <span className="label">Lozinka</span>

                        <Input
                          onChange={(e) => handleOnChange(e)}
                          name="password"
                          id="password"
                          value={data.password || ''}
                          placeholder="*******"
                          type="password"
                        />
                      </>
                    ) : (
                      <span className="value">*******</span>
                    )}
                  </div>
                  <div className="cell">
                    <div className="reset_password_wrapper">
                      <button
                        type="button"
                        className="link_btn"
                        style={{ marginLeft: 0 }}
                        onClick={toogleShowPassword}
                      >
                        <span>Resetuj lozinku</span>
                      </button>
                    </div>
                  </div>
                </div>

                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                  />
                )}

                <div className="row">
                  <div className="submit_wrapper">
                    <Button
                      className="primary_btn"
                      type="button"
                      onClick={() => handleSubmit()}
                      disabled={loading}
                    >
                      <span>
                        {loading ? 'Učitavanje...' : 'Sačuvaj izmene'}
                      </span>
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default EditClinic;
